import React from "react";
import api from '../../api/Api'
import {NavLink} from 'react-router-dom';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Grid from "@material-ui/core/Grid";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import Business from "@material-ui/icons/Business";
import Loader from '../../components/Loader'
import {dashboardRouter, verifyEmail, verifyName, verifyNumber} from '../../util/globalHelper';
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.jsx";
import TagsInput from "react-tagsinput";
import CustomInput from "../../components/CustomInput/CustomInput";

var serviceArray = [];

function getServices(services) {
    services.forEach(function (obj) {
        return serviceArray.push(obj.category);
    })
}


class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            open: true,
            element: "",
            api_status: "",
            read: false,
            alert: null,
            clickedId: "",
            redirect: false,
            redirectOne: false,
            redirectAdd: false,
            loading: true,
            name: "",
            nameState: "",
            description: "",
            descriptionState: "",
            tags: [],
            selectedClinicId: "",
            clinicList: null
        };
        this.change = this.change.bind(this);

    }

    componentDidMount() {
        this.CallReadApi();

    }

    getServices(services) {
        services.forEach(function (obj) {
            return serviceArray.push(obj.category);
        })
    }

    render() {
        const {classes} = this.props;
        const {data, clinicList} = this.state;
        if (this.state.data)
            return (
                <div>
                    {this.state.alert}
                    <Grid container>
                        <GridItem xs={12} sm={12} md={2}>
                            <NavLink to={dashboardRouter("/marketing/notifications/add")}>
                                <Button block color="warning">
                                    <Icon>add</Icon>
                                    <span style={{paddingLeft: 10}}>ADD NEW</span>
                                </Button>
                            </NavLink>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <Business style={{marginTop: 10}}/>
                                            </GridItem>
                                            <GridItem>
                                                <h4>Notifications</h4>
                                                <p>
                                                    List of all Notifications
                                                </p>
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    <ReactTable
                                        data={data}
                                        filterable

                                        defaultFilterMethod={(filter, row) =>
                                            String(row[filter.id]) === filter.value}
                                        columns={[
                                            {
                                                columns: [
                                                    {
                                                        Header: "Title",
                                                        accessor: "title",
                                                        Cell: ({index}) =>
                                                            (<div>
                                                                    <p>{data[index].title}
                                                                    </p>
                                                                </div>
                                                            ),
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["title"]}),
                                                        filterAll: true
                                                    },
                                                    {
                                                        Header: "Text",
                                                        id: "text",
                                                        accessor: "text",
                                                        Cell: ({index}) =>
                                                            (<div>
                                                                    <p>{data[index].text ? data[index].text : ''}</p>
                                                                </div>
                                                            ),
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["text"]}),
                                                        filterAll: true
                                                    }, {
                                                        Header: "Tag",
                                                        id: "tags",
                                                        accessor: "tags",
                                                        Cell: ({index}) =>
                                                            (<div>
                                                                    <p>{
                                                                        data[index].tags ?
                                                                            data[index].tags.toString()
                                                                            : ''}</p>
                                                                </div>
                                                            ),
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["tags"]}),
                                                        filterAll: true
                                                    },
                                                    // {
                                                    //     Header: 'Actions',
                                                    //     id: 'request_state',
                                                    //     filterable: false,
                                                    //     sortable: false,
                                                    //     maxWidth: 160,
                                                    //     Cell: ({index}) =>
                                                    //         (<div>
                                                    //                 <Tooltip
                                                    //                     id="tooltip-top"
                                                    //                     title="Edit"
                                                    //                     placement="bottom"
                                                    //                     classes={{tooltip: classes.tooltip}}>
                                                    //                     <Button type="button" color="success"
                                                    //                             style={{
                                                    //                                 padding: 8,
                                                    //                                 marginLeft: '5%'
                                                    //                             }}
                                                    //                             onClick={() => this.CreateAlert(data[index])}
                                                    //                     >
                                                    //                         <Icon style={{fontSize: 20}}>edit</Icon>
                                                    //                     </Button>
                                                    //                 </Tooltip>
                                                    //             </div>
                                                    //         )
                                                    // }
                                                ]
                                            }
                                        ]}
                                        defaultPageSize={10}
                                        className="-striped -highlight"
                                    />
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

    CallReadApi = () => {
        api.getNotifications({}).then(json => {
            this.setState({data: json.data.data})
        });
    };

    successDelete() {
        this.setState({
            alert: (
                <SweetAlert
                    success
                    style={{display: "block", marginTop: "-100px"}}
                    title="Deleted!"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.success
                    }
                >
                </SweetAlert>
            )
        });
    }

    deleteRecord(id) {
        var postBody = {"clinic_master_id": id};
        api.deleteClinicById(id)
            .then(json => {
            });

    }

    hideAlert() {
        this.setState({
            alert: null
        });
        window.location.reload()

    }

    handleChangeCategories(tags) {
        this.setState({
            tags: tags.filter((v, i, a) => {
                return a.indexOf(v) === i
            })
        })
    }


    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                } else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }

    onUpdate() {

    }

    CreateAlert(data) {
        this.setState({
            name: data.title,
            nameState: "success",
            description: "success",
            descriptionState: data.text,
            tags: data.tags,
            alert: (
                <SweetAlert
                    // warning
                    style={{display: "block", marginTop: "-100px"}}
                    title="Edit"
                    onConfirm={() => {
                        // this.successDelete(),
                        //     this.deleteRecord(id)
                    }}
                    onCancel={() => this.hideAlert()}
                    confirmBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.success
                    }
                    cancelBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.danger
                    }
                    confirmBtnText="Update"
                    cancelBtnText="Cancel"
                    showCancel
                >
                    <form>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <CustomInput
                                    labelText="Title"
                                    id="name"
                                    success={this.state.nameState === "success"}
                                    error={this.state.nameState === "error"}
                                    formControlProps={{
                                        fullWidth: true,
                                        required: true
                                    }}
                                    inputProps={{
                                        onChange: event =>
                                            this.change(event, "name", "name", "required"),
                                        value: this.state.name
                                    }}
                                />
                            </GridItem>
                        </GridContainer>
                        <GridContainer>

                            <GridItem xs={12} sm={12} md={12}>
                                <CustomInput
                                    success={this.state.descriptionState === "success"}
                                    error={this.state.descriptionState === "error"}
                                    labelText="Description "
                                    id="description"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        onChange: event =>
                                            this.change(event, "description", "name", "required")
                                        , value: this.state.description

                                    }}
                                />
                            </GridItem>
                        </GridContainer>

                        <GridContainer>
                            <GridContainer>

                                <GridItem xs={12} sm={12} md={12}>
                                    {/*<h6>Tags</h6>*/}
                                    {/*<br/>*/}
                                    <TagsInput
                                        value={this.state.tags}
                                        onChange={this.handleChangeCategories.bind(this)}
                                        // tagProps={{className: "react-tagsinput-tag warning"}}
                                        inputProps={{placeholder: "Tags"}}
                                    />


                                </GridItem> </GridContainer>


                        </GridContainer>
                    </form>

                </SweetAlert>
            )
        });
    }


}

export default withStyles(sweetAlertStyle)(Notifications);



// WEBPACK FOOTER //
// ./src/views/Notifications/Notifications.jsx